import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { mappingselectionModel } from '../models/mappingselection.model';
import { MappingByHierarchyModel } from '../models/mappingByHierarchy.model';
import { tap } from 'rxjs/operators';
import { AccountDescriptions, Mappings } from '../models/accountDescriptions.model';
import { InfraService } from './infra.service';


@Injectable()
export class MappingService {

  private configCoreUrl: string;

  constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {

      this.configCoreUrl = data.WebEndPoint2;
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedinfraId'));
    }

  }



  public updateMappingSource(engagementId: number, mapingSourceId: number) {

    return this.http.post(`${this.configCoreUrl}MappingSelection/updateMappingSource/${engagementId}/${mapingSourceId}`, { 'a': 'bbbb' });
    // .catch(this.handleError);
  }




  public getMappingAccount(engagementId: number): Observable<mappingselectionModel[]> {
    return this.http.get<mappingselectionModel[]>(`${this.configCoreUrl}MappingSelection/getMappingAccount/${engagementId}`);
    // .catch(this.handleError);
  }

  public createMappingAccount(mappingData: any) {
    return this.http.post(`${this.configCoreUrl}MappingSelection/createMappingAccount/${mappingData.EngagementId}`
      , mappingData.MappingAccount);
    // .catch(this.handleError);
  }

  public getDataByMapping(engId: number, mappingId: number): Observable<MappingByHierarchyModel[]> {

    return this.http.get<MappingByHierarchyModel[]>(`${this.configCoreUrl}MappingSelection/getDataByMapping/${engId}/${mappingId}`);
    // .catch(this.handleError);
  }
  public getMasterStandardizedMapping(engId: number) {

    return this.http.get(`${this.configCoreUrl}MappingSelection/getMasterStandardizedMapping/${engId}`);
    // .catch(this.handleError);
  }



  public getMappingsourceId(engId: number) {

    return this.http.get(`${this.configCoreUrl}MappingSelection/getMappingsourceId/${engId}`);
    // .catch(this.handleError);
  }

  public getAccountId(engId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.configCoreUrl}MappingSelection/getAccountId/${engId}`);
  }

  public getAccountIdCountGreaterThan10Digit(engId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.configCoreUrl}MappingSelection/getAccountIdCountGreaterThan10Digit/${engId}`);
  }

  public deleteProcessingData(engagementId: number) {
    return this.http.post(`${this.configCoreUrl}MappingSelection/deleteMappingData/${engagementId}`, {});
  }

  public saveMappingByHierarchyData(mapping: MappingByHierarchyModel, engId: number, mappingId: number) {

    return this.http.put(`${this.configCoreUrl}MappingSelection/saveMappingByHierarchyData/${engId}/${mappingId}`, mapping);
    // .catch(this.handleError);
  }

  public saveBulkMappingByHierarchyData(mappingList: MappingByHierarchyModel[], engId: number, mappingId: number) {

    return this.http.put(`${this.configCoreUrl}MappingSelection/saveBulkMappingByHierarchyData/${engId}/${mappingId}`, mappingList);
    // .catch(this.handleError);
  }


  public checkChildMappingExistence(mapping: MappingByHierarchyModel, engId: number, mappingId: number) {

    return this.http.put<any>(`${this.configCoreUrl}MappingSelection/checkChildMappingExist/${engId}/${mappingId}`, mapping);
  }

  public checkBulkChildMappingExistence(mapping: MappingByHierarchyModel[], engId: number, mappingId: number) {

    return this.http.put<any>(`${this.configCoreUrl}MappingSelection/checkBulkChildMappingExist/${engId}/${mappingId}`, mapping);
  }

  public getManualMappingTemplate(engagementId: number) {
    return this.http.get(`${this.configCoreUrl}MappingRemediation/GetManualTemplate/${engagementId}`, {
      responseType: 'arraybuffer'
    });
  }

  public getAccountDescriptions(engagementId: number, tabGroupId: number) {
    return this.http.get<AccountDescriptions[]>(`${this.configCoreUrl}MappingRemediation/GetAccountDescriptions/${engagementId}/${tabGroupId}`);
  }

  public getMappingLevelAccountById(engagementId: number, tabGroupId: number) {
    return this.http.get<Mappings[]>(`${this.configCoreUrl}MappingSelection/getmappingLevelByGroupId/${engagementId}/${tabGroupId}`);
  }
  public getAccountDescriptionByMappingId(engagementId: number, groupId: number, mappingId: string) {
    return this.http.get<[]>(`${this.configCoreUrl}MappingSelection/getAccountDescriptionByMappingId/${engagementId}/${groupId}/${mappingId}`);
  }


  public updateStdMappings(accountDescriptions: AccountDescriptions[], engagementId: number, mappingLevel: string) {
    return this.http.post(`${this.configCoreUrl}MappingRemediation/UpdateStdMappings`, {
      'EngagementId': engagementId, 'AccountDescriptions': accountDescriptions, 'mappinglevel': mappingLevel
    });
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
